// extracted by mini-css-extract-plugin
export default {"description":"pageDescription-module__description__tnLKI","descriptionMobile":"pageDescription-module__descriptionMobile__xo5Qu"};